import React from "react";

import { Redirect, Route, Switch } from "react-router-dom";

import { BULKS_ROUTE } from "./routes";
import BulkCreate from "../bulk/BulkCreate";
import BulkDetail from "../bulk/BulkDetail";
import BulkList from "../bulk/BulkList";

import type { JSX } from "react";

function BulkRoutes(): JSX.Element {
  return (
    <Switch>
      <Route exact component={BulkList} path={BULKS_ROUTE} />
      <Route exact component={BulkCreate} path={`${BULKS_ROUTE}/new`} />
      <Redirect
        exact
        from={`${BULKS_ROUTE}/edit/:id`}
        to={`${BULKS_ROUTE}/:id`}
      />
      <Route exact component={BulkDetail} path={`${BULKS_ROUTE}/:id`} />
    </Switch>
  );
}

export default BulkRoutes;
